<template>
	<div class='tax-info wrapper'>
		<AddressPicker/>
		<TaxData v-if='selectedTax.length'/>
	</div>
</template>

<script>
	import AddressPicker from './AddressPicker';
	import TaxData from './TaxData';

	export default {
		name: 'TaxInfo',
		components: {
			AddressPicker,
			TaxData
		},
		computed: {
			selectedTax() {
				return this.$store.state.taxInfo['selectedTax'];
			}
		}
	};
</script>

<!-- <style scoped src='@/style/wrapper.css'></style> -->

<style lang='scss' scoped>
	@import '@/style/constants.scss';

	.tax-info {
		max-width: $wrapper-max-width;
		margin: auto;

		padding: $wrapper-padding;
	}
</style>